import React, { useEffect, useState } from "react";
import styles from "./ChartTypeRadio.module.css";

const ChartTypeRadio = ({ onChange, defaultChecked, leftText, rightText, lImg, rImg, ...props }) => {
  const [checked, setChecked] = useState(defaultChecked);
  const [isInit, setIsInit] = useState(false);
  useEffect(() => {
    if (isInit) onChange(checked);
    if (!isInit) setIsInit(true);
  }, [checked]);

  return (
    <div className={styles.chartTypeRadioDiv}>
      <input
        id="raceTypeCheck"
        type="checkbox"
        className={styles.chartTypeRadioInput}
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <p className={styles.leftText}>{leftText.toUpperCase()}</p>
      <label htmlFor="raceTypeCheck" className={styles.chartTypeRadioLabel} />
      <p className={styles.rightText}>{rightText.toUpperCase()}</p>
      <div className={styles.minImg}>
        <img src={lImg} alt={leftText} className={styles.lImg} onClick={() => setChecked(false)} />
        <img src={rImg} alt={rightText} className={styles.rImg} onClick={() => setChecked(true)} />
      </div>
    </div>
  );
};

export default ChartTypeRadio;
